import { createFileRoute } from "@tanstack/react-router";
import { SITE } from "@/lib/site";

export const Route = createFileRoute("/politica-de-privacidade")({
  head: () => ({
    meta: [
      { title: "Política de Privacidade | SVG Multimídia" },
      {
        name: "description",
        content:
          "Política de Privacidade da SVG Multimídia: como coletamos, usamos, armazenamos e protegemos seus dados pessoais, em conformidade com a LGPD.",
      },
      { name: "robots", content: "index,follow" },
    ],
  }),
  component: PrivacidadePage,
});

function PrivacidadePage() {
  const updated = "26 de junho de 2026";
  return (
    <article className="container-svg max-w-3xl py-16">
      <header className="mb-10">
        <p className="text-xs uppercase tracking-widest text-primary">Documento legal · LGPD</p>
        <h1 className="mt-2 text-4xl font-semibold">Política de Privacidade</h1>
        <p className="mt-3 text-sm text-muted-foreground">Última atualização: {updated}</p>
      </header>

      <div className="prose prose-invert max-w-none space-y-6 text-[15px] leading-relaxed text-muted-foreground">
        <section>
          <h2 className="text-foreground">1. Quem somos</h2>
          <p>
            A {SITE.name} (CNPJ 57.063.169/0001-08), com sede em Frederico Westphalen/RS, é a
            controladora dos dados pessoais coletados por este site, nos termos da Lei Geral de
            Proteção de Dados (Lei nº 13.709/2018 – LGPD).
          </p>
        </section>

        <section>
          <h2 className="text-foreground">2. Dados que coletamos</h2>
          <ul className="list-disc pl-6">
            <li>
              <strong>Dados de contato fornecidos voluntariamente:</strong> nome, e-mail, telefone
              e mensagens enviadas por formulários e WhatsApp.
            </li>
            <li>
              <strong>Dados de navegação:</strong> endereço IP, tipo de dispositivo, navegador,
              páginas visitadas e tempo de permanência, coletados por cookies e ferramentas de
              analytics.
            </li>
            <li>
              <strong>Dados de cadastro (quando aplicável):</strong> e-mail e credenciais de
              autores do blog autenticados.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-foreground">3. Finalidades do tratamento</h2>
          <ul className="list-disc pl-6">
            <li>Responder a contatos comerciais e solicitações de orçamento;</li>
            <li>Executar contratos e prestar os serviços contratados;</li>
            <li>Melhorar a experiência de navegação e o desempenho do site;</li>
            <li>Cumprir obrigações legais e regulatórias;</li>
            <li>Enviar comunicações sobre conteúdos e novidades (mediante consentimento).</li>
          </ul>
        </section>

        <section>
          <h2 className="text-foreground">4. Base legal</h2>
          <p>
            O tratamento dos seus dados é realizado com base no consentimento, na execução de
            contrato, no cumprimento de obrigação legal e no legítimo interesse, conforme previsto
            no art. 7º da LGPD.
          </p>
        </section>

        <section>
          <h2 className="text-foreground">5. Cookies</h2>
          <p>
            Utilizamos cookies próprios e de terceiros (como Google Analytics e Google Maps) para
            métricas, segurança e funcionalidades. Você pode desativar cookies nas configurações
            do seu navegador, ciente de que isso pode impactar a experiência de uso.
          </p>
        </section>

        <section>
          <h2 className="text-foreground">6. Compartilhamento de dados</h2>
          <p>
            Não vendemos seus dados. Compartilhamos informações apenas com fornecedores
            essenciais à operação (hospedagem, e-mail, analytics, CRM) e quando exigido por
            autoridade competente.
          </p>
        </section>

        <section>
          <h2 className="text-foreground">7. Armazenamento e segurança</h2>
          <p>
            Adotamos medidas técnicas e administrativas para proteger seus dados contra acesso
            não autorizado, perda ou alteração. Os dados são mantidos pelo tempo necessário às
            finalidades informadas ou por exigência legal.
          </p>
        </section>

        <section>
          <h2 className="text-foreground">8. Seus direitos (LGPD)</h2>
          <p>Você pode, a qualquer momento, solicitar:</p>
          <ul className="list-disc pl-6">
            <li>Confirmação da existência de tratamento;</li>
            <li>Acesso, correção, anonimização ou exclusão dos seus dados;</li>
            <li>Portabilidade e informação sobre compartilhamentos;</li>
            <li>Revogação do consentimento.</li>
          </ul>
          <p>
            Para exercer seus direitos, entre em contato pelo e-mail{" "}
            <a href={`mailto:${SITE.email}`} className="text-primary hover:underline">
              {SITE.email}
            </a>
            .
          </p>
        </section>

        <section>
          <h2 className="text-foreground">9. Alterações desta política</h2>
          <p>
            Esta Política pode ser atualizada periodicamente. A data da última revisão estará
            sempre indicada no topo desta página.
          </p>
        </section>

        <section>
          <h2 className="text-foreground">10. Contato do encarregado (DPO)</h2>
          <p>
            Dúvidas, reclamações ou solicitações relacionadas aos seus dados pessoais:{" "}
            <a href={`mailto:${SITE.email}`} className="text-primary hover:underline">
              {SITE.email}
            </a>{" "}
            · WhatsApp {SITE.phoneDisplay}.
          </p>
        </section>
      </div>
    </article>
  );
}
